import { ViewModel, View, ObservableArray } from "binder";
import { ColumnFilter } from "../columnFilter";
import  { StringFilterView } from "./stringFilter-view"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class StringFilterViewModel extends ColumnFilter{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.shallUseTables = false;
        this.searchValues = ObservableArray.create<SearchValue>();
    }
    GetDefaultView(): View <ViewModel> {
        return new StringFilterView();
    }
    public getTypeId(): string {
        return "VM-3754F560-9830-4C13-A2D4-F02682C56AEE"
    }
    public set shallUseTables(v: boolean) { this._shallUseTables = v; } public get shallUseTables(): boolean { return this._shallUseTables;} private _shallUseTables: boolean;
    public set containsValue(v: string) { this._containsValue = v; } public get containsValue(): string { return this._containsValue;} private _containsValue: string;
    public set tablename(v: string) { this._tablename = v; this.updateShallUseTables(); } public get tablename(): string { return this._tablename;} private _tablename: string;
    public set columnname(v: string) { this._columnname = v;this.updateShallUseTables(); } public get columnname(): string { return this._columnname;} private _columnname: string;
    public set searchValues(v: ObservableArray<SearchValue>) { this._searchValues = v; } public get searchValues(): ObservableArray<SearchValue> { return this._searchValues;} private _searchValues: ObservableArray<SearchValue>;
    public set comboViewModel(v: ColumnSearcher) { this._comboViewModel = v; } public get comboViewModel(): ColumnSearcher { return this._comboViewModel;} private _comboViewModel: ColumnSearcher;
    public set isExclude(v: boolean) { this._isExclude = v; } public get isExclude(): boolean { return this._isExclude;} private _isExclude: boolean;
        

    updateShallUseTables(){
        if(stringIsNullOrEmpty(this.tablename)==false && stringIsNullOrEmpty(this.columnname)==false){
            this.shallUseTables = true;
            this.comboViewModel = new ColumnSearcher(this);
            this.comboViewModel.tableName = this.tablename;
            this.comboViewModel.columnName = this.columnname;
            this.comboViewModel.onSelectionChanged = (x)=>{
                if(this.searchValues.filter(q=>q.value==x.id).at(0)==null){
                    let value = new SearchValue(this);
                    value.value = x.id;
                    this.searchValues.push(value)
                }
            }
        }else{
            this.shallUseTables = false;
        }
    }
}



export class SearchValue extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:StringFilterViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent : StringFilterViewModel;
    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;

    remove(){
        this._typedParent.searchValues.remove(this);
    }
}

export class ColumnSearcher extends SearchableSelectorBaseViewModel<SingleSearchedValue>{
    constructor(parent:ViewModel) {
        super(parent);
    }
    public tableName : string;
    public columnName : string;
    protected async loadData(searchedText: string): Promise<SingleSearchedValue[]> {
        let result = await ServerConnection.callServer('/Complex/DistinctSelectionService/GetDistinctValues',{
            TableName : this.tableName,
            ColumnName : this.columnName,
            SearchString : searchedText
        });
        return result.Values.map(x=>{
            let r = new SingleSearchedValue(this);
            r.id = x;
            r.title = x;
            return r;
        })
    }
    protected loadById(id: string): Promise<SingleSearchedValue> {
        throw new Error("Method not implemented.");
    }
    
}

export class SingleSearchedValue extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}